import { css } from '@emotion/react';
import { ThemeType } from '@/modules/common';

type BubbleProps = {
  theme: ThemeType;
  isLoadingMessage?: boolean;
  isSingleLine?: boolean;
  isUserMessage?: boolean;
  isSystemMessage?: boolean;
  isLastSystemMessage?: boolean;
};

export const bubbleStyles = ({
  theme,
  isUserMessage,
  isSingleLine,
  isLoadingMessage,
  isSystemMessage,
  isLastSystemMessage,
}: BubbleProps) => css`
  width: ${isSystemMessage ? '100%' : 'auto'};
  max-width: ${isUserMessage ? 'max(280px, 80%)' : isSystemMessage ? '100%' : 'min(500px, max(320px, 90%))'};
  padding: ${isSystemMessage ? '5px' : isSingleLine ? '10px' : '15px'} ${isLoadingMessage ? '12px' : '15px'};
  border: none;
  border-radius: 8px;

  ${theme.bubble.styles};

  ${isUserMessage ? theme.bubble.user : theme.bubble.ml};

  @media (${theme.mediaMobile}) {
    ${isUserMessage ? theme.bubble.user.mobile : theme.bubble.ml.mobile};
  }

  ${
    isSystemMessage && {
      color: '#2f2f2f',
      fontSize: '12px',
      textAlign: 'center',
      borderRadius: '0',
      boxShadow: 'none',
      margin: '15px 0',
    }
  }

  ${
    isSystemMessage &&
    isLastSystemMessage && {
      borderTop: '1px solid #AEAEAE',
    }
  }

  ${
    isSystemMessage &&
    !isLastSystemMessage && {
      borderBottom: '1px solid #AEAEAE',
    }
  }
`;
